<template>
    <div class="children-intake-form">
        <div class="row mb-3 py-2 btn-group-toggle-bg">
            <div class="col mb-1 mb-md-0">
                <div class="btn-group" role="group">
                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="new"
                        autocomplete="off"
                        :checked="status === 'new'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="new"
                        v-on:click="status = 'new'; form = null;"
                    >Nieuw formulier</label>

                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="open"
                        autocomplete="off"
                        :checked="status === 'open'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="open"
                        v-on:click="status = 'open'; form = null;"
                    >Openstaand</label>

                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="done"
                        autocomplete="off"
                        :checked="status === 'done'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="done"
                        v-on:click="status = 'done'; form = null;"
                    >Historie</label>
                </div>
            </div>
        </div>
        <div v-if="isLoading">
            <p>Laden...</p>
        </div>
        <div v-else-if="isLoading === false && form === null">
            <!-- select form / template -->
            <div v-if="status === 'new'">
                <h5>Kies een nieuw formulier</h5>
                <ul v-if="formTemplates && formTemplates.length > 0" class="list-group">
                    <li
                        v-for="template in formTemplates"
                        :key="template.id"
                        v-on:click="editForm(template)"
                        class="list-group-item"
                    >
                        {{ template.title }}
                    </li>
                </ul>
                <p v-else>Geen sjablonen gevonden</p>
            </div>
            <div v-if="status === 'open'">
                <h5>Openstaande formulieren</h5>

                <table class="table" v-if="filledInForms.open.length > 0 ">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Gestart door</th>
                            <th>Gestart op</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="filledInForm in filledInForms.open"
                            :key="filledInForm.id"
                            v-on:click="editForm(filledInForm, true)"
                        >
                            <td>{{ filledInForm.title }}</td>
                            <td>{{ filledInForm.createdBy }}</td>
                            <td>{{ this.$moment(filledInForm.createdAt).format('dddd D MMMM YYYY' ) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="alert alert-info" v-else>Geen ingevulde formulieren</div>
            </div>
            <div v-if="status === 'done'">
                <h5>Historie</h5>
                <ul v-if="filledInForms.done && filledInForms.done.length > 0" class="list-group">
                    <li
                        v-for="filledInForm in filledInForms.done"
                        :key="filledInForm.id"
                        v-on:click="viewForm(filledInForm)"
                        class="list-group-item"
                    >
                        {{ filledInForm.title }}
                        {{ this.$moment(filledInForm.updatedAt).format('dddd D MMMM YYYY' ) }}
                        om
                        {{ this.$moment(filledInForm.updatedAt).format('HH:mm:ss' ) }}
                    </li>
                </ul>
                <div class="alert alert-info" v-else>Geen ingevulde formulieren</div>
            </div>
        </div>
        <div v-else>
            <div
                v-for="(content, contentIndex) in form.questions[0]"
                :key="contentIndex"
            >
                <div class="row mt-2 mb-2">
                    <div
                        v-if="content.type === 'header'"
                        class="col-12"
                    >
                        <p
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'subheader'"
                        class="col-12"
                    >
                        <p
                            class="alert alert-secondary"
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            class="alert alert-secondary"
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'note'"
                        class="col-12"
                    >
                        <p
                            v-if="content.boldText === 1"
                            class="alert alert-info ms-5"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-else
                            class="alert alert-info ms-5"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'description'"
                        class="col-12"
                    >
                        <p
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'question'"
                        class="col-12"
                    >
                        <p
                            class="alert alert-secondary"
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            class="alert alert-secondary"
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;font-size: 12px;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;font-size: 12px;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                </div>
                <div
                    v-if="content.type === 'question' && content['answer'] !== null"
                    class="row">
                    <div
                        class="col-12"
                    >
                        <div
                            v-if="content['answer'].type === 'radio'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div
                                v-for="(answer, idx) in content['answer'].options"
                                :key="idx"
                            >
                                <div v-if="idx !== 'empty' && editMode === true">
                                    <input
                                        v-if="content['answer'].value === answer.id"
                                        :type="content['answer'].type"
                                        :name="content['answer'].type + '-' + contentIndex"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['value']"
                                        checked
                                    />
                                    <input
                                        v-else
                                        :type="content['answer'].type"
                                        :name="content['answer'].type + '-' + contentIndex"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['value']"
                                    />
                                    <span
                                        class="ms-2"
                                        :style="'color:' + answer.color + ';'"
                                    >
                                   {{ answer.name }}
                               </span>
                                    <textarea
                                        v-if="answer.note === 'on'"
                                        class="form-control"
                                        placeholder="Typ hier de toelichting"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText']"
                                    ></textarea>
                                </div>
                                <div v-else>
                                    <div v-if="content['answer'].value === answer.id">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="content['answer'].type === 'select'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div v-if="editMode === true">
                                <select
                                    class="form-select  form-select-sm w-100"
                                    :name="content['answer'].type + '-' + contentIndex"
                                    v-model="form['questions'][0][contentIndex]['answer']['value']"
                                >
                                    <option
                                        v-for="(answer, idx) in content['answer'].options"
                                        :key="idx"
                                        :selected="content['answer'].value === answer.id ? 'selected' : ''"
                                        :value="answer.id"
                                    >
                                        {{ answer.name }}
                                    </option>
                                </select>
                            </div>
                            <div v-else>
                                <div v-for="(answer, idx) in content['answer'].options"
                                     :key="idx"
                                >
                                    <div v-if="content['answer'].value === answer.id">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="content['answer'].type === 'checkbox'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div
                                v-for="(answer, idx) in content['answer'].options"
                                :key="idx"
                            >
                                <div v-if="idx !== 'empty' && editMode === true">
                                    <input
                                        v-if="answer.value"
                                        :type="content['answer'].type"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['value']"
                                        checked
                                    />
                                    <input
                                        v-else
                                        :type="content['answer'].type"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['value']"
                                    />
                                    <span
                                        class="ms-2"
                                        :style="'color:' + answer.color + ';'"
                                    >
                                   {{ answer.name }}
                               </span>
                                    <textarea
                                        v-if="answer.note"
                                        class="form-control"
                                        placeholder="Typ hier de toelichting"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText']"
                                    ></textarea>
                                </div>
                                <div v-else>
                                    <div v-if="answer.value">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else-if="content['answer'].type === 'text'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'"
                        >
                            <input
                                v-if="editMode === true"
                                type="text"
                                class="form-control"
                                :placeholder="content.text"
                                v-model="form['questions'][0][contentIndex]['answer']['value']"
                            />
                            <div v-else>
                            <span v-if="content['answer'].value">
                                {{ content['answer'].value }}
                            </span>
                                <span v-else>
                                -
                            </span>
                            </div>
                        </div>
                        <div
                            v-else-if="content['answer'].type === 'textarea'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'"
                        >
                        <textarea
                            v-if="editMode === true"
                            class="form-control"
                            :placeholder="content.text"
                            v-model="form['questions'][0][contentIndex]['answer']['value']"
                        ></textarea>
                            <div v-else>
                            <span v-if="content['answer'].value">
                                {{ content['answer'].value }}
                            </span>
                                <span v-else>
                                -
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div
                v-if="editMode === true"
                class="d-grid gap-2"
            >
                <button v-on:click="saveForm(0)" class="btn btn-info">
                    Opslaan
                </button>
                <button v-on:click="saveForm(1)" class="btn btn-info">
                    Opslaan en definitief maken
                </button>
                <button v-on:click="cancelForm()" class="btn btn-danger">
                    Annuleren
                </button>
            </div>
            <div v-else>
                <button
                    v-on:click="form = null"
                    class="btn btn-block btn-secondary"
                >
                    Terug naar overzicht
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'children-intake-form',
    created() {
        this.loadFilledInQuestionnairesByIdChild(this.selectedChild.id)
        this.loadQuestionnaireTemplates()
    },
    methods: {
        viewForm(filledInForm) {
            this.editMode = false
            this.form = JSON.parse(filledInForm.jsonContent)
            this.id = filledInForm.id
            this.idGeneralForm = filledInForm.idGeneralForm
            this.idQuestionnaireTemplate = filledInForm.idQuestionnaireTemplate
        },
        editForm(template, edit = false) {
            this.editMode = true
            this.form = JSON.parse(template.jsonContent)
            this.id = edit ? template.id : null
            this.idGeneralForm = template.idGeneralForm
            this.idQuestionnaireTemplate = template.idQuestionnaireTemplate
        },
        saveForm(formStatus) {
            this.status = 'open'
            if (formStatus === 1) {
                this.status = 'done'
            }
            this.$request.post(process.env.VUE_APP_API_V3_URL +  '/saveQuestionnaire', {
                ...this.$request.getDeprecatedBodyAuthentication(),
                id: this.id,
                idGeneralForm: this.idGeneralForm,
                idQuestionnaireTemplate: this.idQuestionnaireTemplate,
                idChild: this.selectedChild.id,
                status: formStatus,
                json: JSON.stringify(this.form)
            })
                .then(data => {
                    if (data) {
                        if (data.saved === true) {
                            this.loadFilledInQuestionnairesByIdChild(this.selectedChild.id)
                            this.form = null
                            return true
                        }
                    }
                    alert('Fout bij het opslaan, probeer opnieuw')
                })
        },
        cancelForm() {
            if (confirm('Weet je zeker dat je het formulier NIET wilt opslaan?')) {
                this.form = null
            }
        },
        loadFilledInQuestionnairesByIdChild(id_child) {
            this.isLoading = true
            this.filledInForms = {
                open: [],
                done: [],
            }

            this.$request.post(process.env.VUE_APP_API_V3_URL + '/filledInGeneralForms', {
                ...this.$request.getDeprecatedBodyAuthentication(),
                idChild: id_child
            })
                .then(data => {
                    this.isLoading = false
                    if(Array.isArray(data)) {
                        data.forEach((element) => {
                            if (element.status === 0) {
                                this.filledInForms.open.push(element)
                            } else {
                                this.filledInForms.done.push(element)
                            }
                        });
                        if (this.filledInForms.open.length > 0) {
                            this.status = 'open'
                        }
                    }
                })
        },
        loadQuestionnaireTemplates() {
            this.isLoading = true
            this.$request.post(process.env.VUE_APP_API_V3_URL + `/getQuestionnaireGeneralForms`, {
                ...this.$request.getDeprecatedBodyAuthentication(),
                utilization: 3
            })
                .then(generalForms => {
                    this.isLoading = false
                    this.formTemplates = generalForms
                })
        },
        getJsonFromForm() {
            return JSON.stringify(this.form)
        },
        calculateMargin(margin) {
            return parseInt(margin) + 10;
        }
    },
    data() {
        return {
            isLoading: false,
            status: 'new',
            formTemplates: null,
            filledInForms: {
                open: [],
                done: [],
            },
            editMode: true,
            form: null,
            id: null,
            idQuestionnaireTemplate: null,
            idGeneralForm: null
        }
    }
}
</script>

<style scoped>
select {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    background-color: #ffffff;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 16px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #c8c8c8 !important;
}

.btn-group-toggle-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.btn-group-toggle-bg label {
    margin: 0;
}
.btn-group-toggle-bg .btn-outline-secondary {
    background-color: #fff;
    border-color: rgba(0,0,0,.2);

    &:hover {
        background-color: rgba(0,0,0,.01);
    }
}
.btn-group-toggle-bg .btn-check:checked + .btn {
    color: inherit;
    background-color: rgb(240, 240, 245);
    border-color: rgba(0,0,0,.3);
    box-shadow: none;
}
</style>
